import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button, Col,
    FormText
} from "reactstrap";

import { getData, updateData } from 'core/ducks/update';
import T from 'modules/i18n';

class ChargeApplication extends Component {

    constructor(props) {
        super(props);
        this.state = {
            proxies: [],
            selectedProxy: props.current,
            isConfirmStateEnabled: false,
        };
    }

    componentDidMount() {
        this.loadProxyData();
    }

    loadProxyData = () => {
		this.props.dispatch( getData('app/member/role/proxy') )
			.then((proxies) => {
				this.setState({proxies});
			});
	}

    handleSubmit = (event) => {
        event.preventDefault();
        const { dispatch, toggle, application, scope } = this.props;
        dispatch(
            updateData(scope==='application' ? `app/registry-admin/application/${application}` : `app/registry-admin/license/${application}`, {"action": "charge", "proxy": this.state.selectedProxy})
        ).then(toggle);
    }

    handleChange = (event) => {
        if (this.state.isConfirmStateEnabled)
            return;
        const { checked, value } = event.target;
        if (checked) {
            this.setState({selectedProxy: value});
        }
    }

    render() {
        const { isOpen, cancel, registry_number, scope } = this.props;
        const { proxies, selectedProxy } = this.state;

        return (
            <Modal size="md" isOpen={isOpen}>
                <ModalHeader toggle={cancel}>
                    <T>{scope==='application' ? 'application charge' : 'licence charge'}</T> {registry_number}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={this.handleSubmit}>
                        { proxies.filter(e => e.accepted).map(({user, identifier, firstname, lastname, email}) => (
                            <FormGroup key={`proxy_${user}`} check>
                                <Label check>
                                    <Input type="radio" checked={user === selectedProxy} value={user} onChange={this.handleChange} />
                                    <Col><b>{`${firstname} ${lastname} - `}</b> {identifier}</Col>
                                    <Col><span className="link-primary">{email}</span></Col>
                                </Label>
                            </FormGroup>
                        ))}
                        { this.state.isConfirmStateEnabled &&
                            <FormText color="warning" className="px-5 py-3">
                                Αν συνεχίσετε η διαχείριση της {scope==='application' ? 'αίτησης' : 'άδειας'} {registry_number} {scope==='application' ? 'μαζί με τα αρχεία που την συνοδεύουν θα περάσουν ' : 'θα περάσει '}
                                στον επιλεγμένο αντίκλητο.
                            </FormText>
                        }
                        <div className="d-flex justify-content-end">
                            { this.state.isConfirmStateEnabled ?
                                <>
                                    <Button className="mr-2" color="info" onClick={() => cancel()}><T>cancel</T></Button>
                                    <Button type="submit" color="warning"><T>continue</T></Button>
                                </>
                                :
                                <Button disabled={selectedProxy === this.props.current} outline color="success" onClick={() => this.setState({isConfirmStateEnabled: true})}><T>submit</T></Button>
                            }
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        );
    }

}

ChargeApplication.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	cancel: PropTypes.func.isRequired,
    registry_number: PropTypes.string.isRequired,
    current: PropTypes.string,
    toggle: PropTypes.func.isRequired,
    application: PropTypes.string.isRequired,
    scope: PropTypes.oneOf(['application', 'licence']),
};

ChargeApplication.defaultProps = {
    scope: 'application',
    current: '',
};

ChargeApplication = connect(null)(ChargeApplication);

export default ChargeApplication;
